var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.container,{tag:"component",staticClass:"icon",domProps:{"innerHTML":_vm._s(_vm.iconMarkup)},on:{"click":_vm.handleClick}})}
var staticRenderFns = []

export { render, staticRenderFns }